const monthlyIncomeLength = (value) => {
  if (!value) {
    return false;
  }
  return value.replace('.', '').length <= 5;
};
export default monthlyIncomeLength;
